export const SESSION_PAGE_SIZE = 25;
export const STUDENT_PAGE_SIZE = 50;
